import { render, staticRenderFns } from "./CustomerContracts.vue?vue&type=template&id=01370694"
import script from "./CustomerContracts.vue?vue&type=script&lang=js"
export * from "./CustomerContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports